"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));
var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));
var _SttMenu = _interopRequireDefault(require("./SttMenu"));
var _SttMenuItem = _interopRequireDefault(require("./SttMenuItem"));
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      color: theme.palette.background["default"],
      '&$selected': {
        color: theme.palette.background["default"],
        borderBottom: '4px solid'
      },
      '&$selected $wrapper': {
        marginBottom: '-4px'
      },
      minWidth: 'auto'
    },
    selected: {},
    wrapper: {}
  };
});
var propriedadesMenu = (0, _styles.makeStyles)(function (theme) {
  return {
    menu: {
      marginTop: theme.spacing(5)
    }
  };
});
var tabsIndicator = (0, _styles.makeStyles)(function (theme) {
  return {
    indicator: {
      display: 'none'
    }
  };
});
var tabsClasses = (0, _styles.makeStyles)(function (theme) {
  return {
    flexContainer: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  };
});
var SttNavigationBar = function SttNavigationBar(_ref) {
  var submenus = _ref.submenus,
    _ref$selectedTab = _ref.selectedTab,
    selectedTab = _ref$selectedTab === void 0 ? 0 : _ref$selectedTab,
    _ref$callback = _ref.callback,
    callback = _ref$callback === void 0 ? null : _ref$callback;
  var classes = useStyles();
  var tabsInd = tabsIndicator();
  var tabsCls = tabsClasses();
  var menuProps = propriedadesMenu();
  var _React$useState = _react["default"].useState(selectedTab),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    tabSelecionada = _React$useState2[0],
    selecionarTab = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    anchorEl = _React$useState4[0],
    setAnchorEl = _React$useState4[1];
  var _React$useState5 = _react["default"].useState([]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    itensMenu = _React$useState6[0],
    setItensMenu = _React$useState6[1];
  var handleOpenMenu = function handleOpenMenu(e, item) {
    setAnchorEl(e.currentTarget);
    if (item.list) {
      setItensMenu(item.list);
    }
  };
  var handleMenuClose = function handleMenuClose() {
    setAnchorEl(null);
    selecionarTab(false);
  };
  var onClickItem = function onClickItem(item, e) {
    //Se houver itens para um submenu, monta o menu com esses itens
    if (item.list) {
      handleOpenMenu(e, item);
    }
    //Se houver um click no menu, realiza a sua ação
    if (item.onClick) {
      item.onClick();
    }
  };
  (0, _react.useEffect)(function () {
    selecionarTab(selectedTab);
  }, [selectedTab]);
  var handleChange = function handleChange(event, newValue) {
    selecionarTab(newValue);
    callback && callback(event, newValue);
  };
  var renderItem = function renderItem(item, index) {
    return /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
      key: index,
      value: index,
      label: item.text,
      onClick: function onClick(e) {
        onClickItem(item, e);
      },
      classes: classes,
      disableRipple: true,
      "aria-controls": "menu"
    });
  };
  var renderItemMenu = function renderItemMenu(item, index) {
    return /*#__PURE__*/_react["default"].createElement(_SttMenuItem["default"], {
      key: index,
      value: index,
      label: item.text,
      onClick: function onClick() {
        if (item.onClick) {
          item.onClick();
        }
        handleMenuClose();
      }
    }, item.text);
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Tabs["default"], {
    value: tabSelecionada,
    onChange: handleChange,
    variant: "scrollable",
    classes: tabsCls,
    TabIndicatorProps: {
      className: tabsInd.indicator
    }
  }, submenus.map(function (item, index) {
    return renderItem(item, index);
  })), /*#__PURE__*/_react["default"].createElement(_SttMenu["default"], {
    id: "menu",
    onClose: handleMenuClose,
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    className: menuProps.menu
  }, itensMenu.map(function (item, index) {
    return renderItemMenu(item, index);
  })));
};
var _default = SttNavigationBar;
exports["default"] = _default;